/***************************************************************************************
 * @module       Session Handler 
 * @name         SessionHandler
 * @description  Handles session management, authentication, and WebSocket connections
 * @version      1.0.0
 * @license      Licensed under the MIT License
 * @createdon    May 2025
 * @since        1.0
 ***************************************************************************************/

import React, { useState, useEffect } from 'react';
import AlertModal from '../genriccomponents/AlertModal';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import ServiceUtils from '../utils/techus-serviceUtils'; // Adjust the import based on your project structure
import CONFIG from '../config/config';
import io from 'socket.io-client';
import Loader from '../genriccomponents/loaders/RedLoader';
import { UserInfoByToken } from '../services/techus-services';

const API_BASE_URL = `${CONFIG.API_URL}`;
const API_LANDING_KEY = CONFIG.REACT_APP_LANDING_AUTHORIZATION_KEY;

const httpClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

const utilsService = ServiceUtils();

const SessionHandler = () => {
  const [showModal, setShowModal] = useState(false);
  const [loader,setLoader] =useState(false)
  const [modalData, setModalData] = useState({ title: '', content: '' });
  const history = useNavigate();
  
  const handleLogoutOkay = async() => {
      setLoader(true)
      const token =localStorage.getItem('user_access_token')
      if (!token) {
        localStorage.removeItem("user_access_token");
        localStorage.clear();
        setShowModal(false);
        history('/login');
      }
      try {
        const response = await UserInfoByToken({ token });
        if(response.valid){
          if(response.user.length==0){
            localStorage.removeItem("user_access_token");
            localStorage.clear();
            setShowModal(false);
            history('/login');
          }else{
             window.location.reload()
          }
        }else{
          localStorage.removeItem("user_access_token");
            localStorage.clear();
            setShowModal(false);
            history('/login');
        }
        setLoader(false)
      } catch (error) {
        throw error;
      
    };
    
  };
  const user_data=localStorage.getItem('uuid')
  useEffect(() => {
    // Connect to the WebSocket server
    const socket = io(CONFIG.SOCKET_URL); // Replace with your server URL
    const user_id_name ='user_'+user_data
    // Listen for the 'import_progress' event
    socket.on(user_id_name, (data) => {
      if(data.message=='log_out'){
        localStorage.removeItem("user_access_token");
        localStorage.clear();
          window.location.reload()
        // var data_1 = { head: 'Force Log Out', text: 'You will be logging out of this session due to the inactivity from another tab.' };
      }else if(data.message=='password_reset'){
          const data_3 = { head: 'Password Update', text: 'Due to security reasons, we are logging you out from the portal. Please log in again to access your account.' };
          setModalData({ title: data_3.head, content: data_3.text });
          setShowModal(true);
        
      }
      else{
        setTimeout(()=>{
          window.location.reload()
        },2000)
        
        setTimeout(() => {
          var data_1 = { head: 'Force Log Out', text: 'You will be logged out from this device because your account is currently active on another device. Please log in again if you wish to continue using this device.' };
          setModalData({ title: data_1.head, content: data_1.text });
          setShowModal(true);
        }, 3000); 
        
        
      }
       
        //   console.log('Received import_progress event: ', data);
    });

    // Clean up the socket connection on component unmount
    return () => {
        socket.disconnect();
    };
}, []);

  const checkSessionExpire = (data) => {
    setModalData({ title: data.head, content: data.text });
    setShowModal(true);
  };

  useEffect(() => {
    const interceptorRequest = httpClient.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem("user_access_token");
        config.headers.Authorization = token && config.url!=='/login' ? `Bearer ${token}` : API_LANDING_KEY;
        return config;
      },
      (error) => Promise.reject(error)
    );

    const interceptorResponse = httpClient.interceptors.response.use(
      (response) => {
        if (response.data.session_expired === 1) {
          const data = { head: 'Session Expired', text: 'Your session has expired. Please log in again.' };
          checkSessionExpire(data);
        } else if (response.data.force_logout === 1) {
          const data = { head: 'Force Log Out', text: 'You will be logged out from this device because your account is currently active on another device. Please log in again if you wish to continue using this device.' };
          checkSessionExpire(data);
        } else if (response.data.edata) {
          // Encrypted response payload — decrypt and return.
          return utilsService.prepareAPIResponse(response.data.edata);
        } else {
          // Plain unencrypted response (e.g. login auth-failure messages,
          // some legacy endpoints). Pass through as-is.
          return response.data;
        }
        return Promise.resolve(response);
      },
      (error) => {
        if (error.response && error.response.status === 401) {
          console.error('Unauthorized access, logging out');
          handleLogoutOkay()
        }
        return Promise.reject(error);
      }
    );

    return () => {
      httpClient.interceptors.request.eject(interceptorRequest);
      httpClient.interceptors.response.eject(interceptorResponse);
    };
  }, []);

  return (
    <>
    {loader && <Loader /> }
      {showModal && (
        <AlertModal
          button="Log Out"
          title={modalData.title}
          content={modalData.content}
          handleOkay={handleLogoutOkay}
        />
      )}
    </>
  );
};

export { httpClient, SessionHandler };
